import { axiosInstance, CustomResponseFormat } from "api/instance";

export const PROGRAM_SETUP_DOMAIN = "program-setup";

export const PAGE_SAVE_ENDPOINT = "page/save";
export const START_ENDPOINT = "start";
export const PAGE_DATA_SAVE_ENDPOINT = "page-data/save";
export const PAGE_ALL_DATA_LOAD_ENDPOINT = "page-all-data/load";
export const LAST_PAGE_LOAD_ENDPOINT = "page-last/load";
export const QA_DETAIL_ENDPOINT = "qa/detail";

export interface ProgramSetupPage {
  setupSeq?: string;
  pageId?: string;
  params?: string;
}

export interface OnboardingDemographicType {
  genderId?: number;
  age?: number;
  jobId?: number;
}

export interface ProgramSetupDataState {
  [pageKey: string]: DataState; // pageKey key로 하여 SelectState를 값으로 담는 객체
}

export interface QA {
  questionId: number;
  answerId: number;
}

export interface DataState {
  multiSelectionIdList?: number[];
  singleSelectionId?: number;
  qaList?: QA[];
  text?: string;
}

export interface OnboardingAnalysisDetailResult {
  status?: "processing" | "completed";
  analysisList?: SurveyAnalysisDetailItem[];
}

export interface SurveyAnalysisDetailItem {
  title: string;
  content: string;
}

export interface ProgramSetupQADetailType {
  pageGoal2Answer?: string; // 자신있고 주체적인 삶, 일상의 작은 행복을 만끽하는 삶
  pageGoal3Answer?: string; // 외부 환경의 변화 (진학, 이직 등)
  pageGoal5Answer?: string; // 우울, 범불안
  motivation7Answer?: string; // 배우자/연인, 부모/자식
}

export const PROGRAM_SETUP_QA_DETAIL_DEFAULT: ProgramSetupQADetailType = {
  pageGoal2Answer: "평안하고 여유로운 마음을 가진 삶",
  pageGoal3Answer: "여러 외부적 요인",
  pageGoal5Answer: "부정적",
  motivation7Answer: "기타",
};

export const programSetupApi = {
  start: () =>
    axiosInstance.post<void>(`${PROGRAM_SETUP_DOMAIN}/${START_ENDPOINT}`),

  savePage: (setupSeq: number, pageId: string, params?: string) =>
    axiosInstance.post<void>(`${PROGRAM_SETUP_DOMAIN}/${PAGE_SAVE_ENDPOINT}`, {
      setupSeq: setupSeq,
      pageId: pageId,
      params: params,
    }),

  savePageData: (pageId: string, data: DataState) =>
    axiosInstance.post<void>(
      `${PROGRAM_SETUP_DOMAIN}/${PAGE_DATA_SAVE_ENDPOINT}`,
      { pageId: pageId, data: JSON.stringify(data) }
    ),

  loadAllPageData: () =>
    axiosInstance.get<CustomResponseFormat<ProgramSetupDataState>>(
      `${PROGRAM_SETUP_DOMAIN}/${PAGE_ALL_DATA_LOAD_ENDPOINT}`
    ),

  loadLastPage: (setupSeq: number) =>
    axiosInstance.get<CustomResponseFormat<ProgramSetupPage>>(
      `${PROGRAM_SETUP_DOMAIN}/${LAST_PAGE_LOAD_ENDPOINT}`,
      { params: { setup_seq: setupSeq } }
    ),

  getQADetail: () =>
    axiosInstance.get<CustomResponseFormat<ProgramSetupQADetailType>>(
      `${PROGRAM_SETUP_DOMAIN}/${QA_DETAIL_ENDPOINT}`
    ),
};
